<template>
  <div
      id="service-tel"
      :style="`
        height: ${height};
        background-color: ${backgroundColor};
        font-size: ${textSize};
        color: ${color};
      `"
  >
    客服咨询: (0757)23320399
  </div>
</template>

<script>
  export default {
    name: "serviceTel",
    props:{
      backgroundColor:{
        type:String,
        default:'#f5f7fa',
      },
      color:{
        type:String,
        default:'#909399',
      },
      height:{
        type:String,
        default:'9.067vw',
      },
      textSize:{
        type:String,
        default:'2.933vw',
      }
    },
  }
</script>

<style scoped>
  #service-tel{
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
